/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["သန်းခေါင်ယံ","မွန်းတည့်","နံနက်","နေ့လယ်","ညနေ","ည"],u,u],u,["00:00","12:00",["00:00","12:00"],["12:00","16:00"],["16:00","19:00"],["19:00","24:00"]]];
